import React, { useState } from 'react';

import Button, { ButtonGroup, LoadingButton } from '@atlaskit/button';
import SectionMessage from '@atlaskit/section-message';

import { trackEvent } from 'src/lib/analytics';
import jira from 'src/lib/api/jira';
import pd from 'src/lib/api/pagerduty';
import { getQueryParams } from 'src/lib/history';

import ErrorMessage from 'src/views/components/ErrorMessage';
import ModalContainer from 'src/views/components/ModalContainer';
import { PdPrioritySelect } from 'src/views/components/select';

const analyticsEventName = 'sidebar_incidentresponse_change_priority';
const ModalChangePriority = () => {
  const [priority, setPriority] = useState(null);
  const [porcessing, setProcessing] = useState(false);

  const [{ errorMessage, successMessage }, setError] = useState({});

  const closeModal = () => {
    trackEvent(analyticsEventName, { label: 'cancel' });
    jira.closeCurrentModal();
  };

  const onChange = ({ target: { value } = {} }) => {
    if (value) setPriority(value);
  };

  const changePriority = () => {
    setProcessing(true);
    trackEvent(analyticsEventName, { label: 'change_priority' });
    const { incidentId } = getQueryParams();
    let bodyPriority = (priority.id) ? priority : null; // No Priority option
    pd.setPriority(incidentId, bodyPriority)
      .then(() => {
        setProcessing(false);
        setError({ successMessage: 'Priority changed' });
        jira.closeCurrentModal();
      })
      .catch(error => {
        setProcessing(false);
        setError({ errorMessage: error });
      });
  };
  return (
    <ModalContainer title="Change PagerDuty Priority">
      <div
        style={{
          display: 'flex',
          flexFlow: 'column nowrap',
          minHeight: '260px',
        }}
      >
        <PdPrioritySelect
          placeholder="Any"
          name={'pd_priorities'}
          value={priority}
          onChange={onChange}
        />
        <div style={{ flexGrow: 1, minHeight: 30 }} >
          {successMessage && (
            <div data-cy="info-message">
              <SectionMessage title="Partial success">
                {successMessage}
              </SectionMessage>
            </div>
          )}

          {errorMessage && (
            <ErrorMessage error={['Failed to changePriority', errorMessage]} />
          )}
        </div>
        <div
          style={{
            paddingTop: 24,

            display: 'flex',
            justifyContent: 'flex-end',
          }}
        >
          <ButtonGroup>
            <Button onClick={closeModal}>Cancel</Button>
            <LoadingButton isLoading={porcessing} isDisabled={!priority} onClick={changePriority}>
              Change Priority
            </LoadingButton>
          </ButtonGroup>
        </div>

      </div>
    </ModalContainer>
  );
};

export default ModalChangePriority;
